import React, { useEffect } from 'react';

const useOnClickOutside = (
  ref: React.MutableRefObject<HTMLElement | undefined>,
  handler: (e: Event) => void,
  active: boolean = true,
) => {
  useEffect(() => {
    if (!active) {
      return;
    }
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
